import styled from 'styled-components';
export const NickName = styled.span `
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80px;
  display: block;
  margin-left: var(--spacing-0-5);
  font-size: var(--font-size-xxs);
`;
export const Item = styled.li `
  list-style: none;
  display: flex;
  align-items: center;

  & .profile-link {
    font-family: var(--font-family);
    font-size: var(--font-size-xxs);
    line-height: var(--font-lineheight-medium);
    font-weight: var(--font-weight-semibold);
    color: var(--color-neutral-130);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 135px;
    border-radius: var(--border-radius-pill);
    padding: var(--spacing-0-5);
    border: 0;
    border: 1px solid var(--color-neutral-110);
    height: 40px;
    transition: all ease var(--transition-duration-3);
    background-color: transparent;
    cursor: pointer;

    &:hover {
      border-color: var(--color-secondary-100);
      text-decoration: none;
      color: var(--link-color-main-hover);
    }

    &:focus {
      box-shadow: none;
      outline: var(--border-width-thin) solid var(--color-neutral-130);
      border-radius: var(--border-radius-pill);
    }

    @media all and (max-width: 839px) {
      display: none;
    }
  }
`;
